<template>
  <div
    class="flex flex-col gap-2 p-4 bg-[var(--fundoForm);] rounded-[10px] bg-opacity-[0.55]"
  >
    <div
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <h3 style="color: var(--titulo)">Transferir Artigos da Viatura</h3>
      <div>
        <AppButton
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="20"
          :height="20"
        />
      </div>
    </div>
    <div
      class="w-full flex flex-col gap-4 bg-[var(--fundoComponente)] rounded-[10px] bg-opacity-[0.55] text-[var(--text)]"
    >
            <div class="flex flex-wrap gap-2  w-full items-center ">
                <div class="flex gap-2">
                    <label class="text-[var(--text)]">Tecnico:</label>
                    <!-- <input v-if="edit_mode" :disabled="true" type="text" v-model="item_proposta.equipamento.nome"
                    class="text-[var(--text)] text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-96"> -->
          <input
            style="color: var(--text)"
            v-bind:style="{
              backgroundColor: !tecnico.user
                ? 'var(--obrigatorio)'
                : 'var(--label)',
            }"
            :disabled="true"
            type="text"
            v-model="tecnico.user"
            class="text-[var(--text)] text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-[18rem]"
          />
        </div>
        <button
          class="fa-solid fa-pen-to-square text-2xl"
          v-bind:style="{
            color: tecnico.id === 0 ? 'var(--obrigatorio)' : 'var(--icon)',
          }"
          @click="open_dialog_alert('tecnico')"
        ></button>

        <!-- <div class=" m-6 flex items-center">
                    <button class="fa-solid fa-arrows-rotate text-2xl " :style="{ color: '#ff9b05' }"
                        @click="swapArmazem"></button>
                </div> -->

                <div class="flex gap-2">
                    <label class="text-[var(--text)]">Armazem Viatura:</label>
                    <!-- <input v-if="edit_mode" :disabled="true" type="text" v-model="item_proposta.equipamento.nome"
                    class="text-[var(--text)] text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-96"> -->
          <input
            style="color: var(--text)"
            v-bind:style="{
              backgroundColor: !armazemViatura.nome
                ? 'var(--obrigatorio)'
                : 'var(--label)',
            }"
            :disabled="true"
            type="text"
            v-model="armazemViatura.nome"
            class="text-[var(--text)] text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-[18rem]"
          />
        </div>
        <!-- <button class="fa-solid fa-pen-to-square text-2xl " :style="{ color: '#ff9b05' }"
                    @click="open_dialog_alert('armazemViatura')"></button> -->

        <div class="m-6 flex items-center">
          <i
            class="fa-solid fa-arrows-turn-right text-2xl"
            :style="{ color: 'var(--label)' }"
          ></i>
        </div>

                <div class="flex gap-2">
                    <label class="text-[var(--text)]">Armazem Destino:</label>
                    <!-- <input v-if="edit_mode" :disabled="true" type="text" v-model="item_proposta.equipamento.nome"
                    class="text-[var(--text)] text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-96"> -->
          <input
            style="color: var(--text)"
            v-bind:style="{
              backgroundColor: !armazemDestino.nome
                ? 'var(--obrigatorio)'
                : 'var(--label)',
            }"
            :disabled="true"
            type="text"
            v-model="armazemDestino.nome"
            class="text-[var(--text)] text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-[18rem]"
          />
        </div>
        <button
          v-bind:style="{
            color:
              armazemDestino.id === 0 ? 'var(--obrigatorio)' : 'var(--icon)',
          }"
          class="fa-solid fa-pen-to-square text-2xl"
          @click="open_dialog_alert('armazemDestino')"
        ></button>

        <div class="flex gap-2 ml-auto items-center">
          <AppButton
            class="capitalize"
            v-bind:visibility="true"
            :font_size="12"
            style="background-color: var(--button); color: var(--label)"
            text="Transferir"
            emitType="select"
            @select="transferir"
          />
        </div>
      </div>

      <div class="w-full">
        <!-- <AppTable :visibility="this.validPermission('G0006')" :show="show_table" :table_data="artigos" :table_title="table_title"
                  @row-clicked="select_artigo" @close="close_table" @delete_data="remove_artigo" /> -->
        <AppTablePagination
          :visibility="true"
          :show="armazemViatura.id != 0"
          :groupby="{ show: true, field: 'equipamento', toggle: true }"
          table_title="Artigos"
          :refresh="refresh"
          @row-clicked=""
          @close=""
          @delete_data=""
          @refreshed="refresh = false"
          class="h-full"
          :urlString="`armazem/${armazemViatura.id}/estoque`"
        />
      </div>
    </div>

    <!-- <div class="flex gap-2 mt-2 items-center">
            <AppButton class="capitalize" v-bind:visibility="true" :font_size="12" color="#9797EF" text="Transferir"
                emitType="select" @select="transferir" />

        </div> -->
  </div>
  <!-- <genericPopUp v-if="showPopUp" title="Editar" :model="{ observacao: item_validacao.observacao }"
        @close="showPopUp = false" @save_form="set_observacao" :edit_mode="active_state.includes(negocio.status)" /> -->
  <Dialog
    v-if="dialogStatus"
    @close="dialogStatus = false"
    @returnData="setSelectResult"
    :propsData="dialogProps"
    :pagination="true"
  />
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import Dialog from "@/components/dialog/dinamicDialog.vue";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import axios from "axios";

import AppTable from "@/components/tables/table.vue";
import AppTablePagination from "@/components/tablePagination/tablePagination.vue";

export default {
  name: "artigoTransfer",
  //J.. 03_03
  props: {
    parent_tecnico: {
      type: Object,
      default: () => {
        return { id: 0, user: "" };
      },
    },
    // 🔥 Nova prop para receber o armazemId do armazensView.vue
  },
  components: {
    AppButton,
    Dialog,
    AppTablePagination,
    AppTable,
    AppTablePagination,
  },
  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,
      emit_type: "",
      dialogStatus: false,
      dialogProps: {
        multi: false,
        entity: ["equipamento", "armazem"],
        //sideBar: true,
        queryParams: {},
      },
      currentType: "",
      refresh: false,

      artigo: {
        equipamento: { id: 0, nome: "" },
      },

      armazemDestino: { id: 0, nome: "" },
      armazemViatura: { id: 0, nome: "" },
      tecnico: { id: 0, user: "" },

      refresh: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },

    open_dialog_alert(key) {
      this.currentType = key;
      this.dialogProps.title = key;
      // if (key == 'equipamento' && this.artigo.armazemDestino.id == 0) {
      //     toast("Selecione o Armazem Origem", {
      //         "theme": "auto",
      //         "type": "warning",
      //         "position": "top-center",
      //         "autoClose": 1000,
      //     });
      //     return
      // }

      if (key == "equipamento") {
        console.log("key:", key);
        this.dialogProps.entity = [
          "equipamento/armazem/" + this.artigo.armazemDestino.id,
        ];
        this.dialogStatus = true;
      } else if (key == "tecnico") {
        console.log("key:", key);
        this.dialogProps.entity = ["tecnico"];
        this.dialogStatus = true;
      } else if (key == "armazemDestino" || key == "armazemViatura") {
        console.log("key:", key);
        this.dialogProps.entity = ["armazem"];
        this.dialogStatus = true;
      }
      // this.$emit('open_dialog_alert',key)
    },

    setSelectResult(result) {
      console.log("result:", result);
      if (result["equipamento"]) {
        this.artigo.equipamento = result["equipamento"];
      } else if (result["armazemDestino"]) {
        if (result["armazemDestino"].id == this.armazemViatura.id) {
          toast("Armazem de Origem não pode ser igual ao Armazem de Destino", {
            theme: "auto",
            type: "warning",
            position: "top-center",
            autoClose: 1000,
          });
          return;
        }
        this.armazemDestino = result["armazemDestino"];
        // this.artigo.equipamento = { id: 0, nome: "" }
        // this.artigo.stock = 0
      } else if (result["armazemViatura"]) {
        if (result["armazemViatura"].id == this.armazemDestino.id) {
          toast("Armazem de Destino não pode ser igual ao Armazem de Origem", {
            theme: "auto",
            type: "warning",
            position: "top-center",
            autoClose: 1000,
          });
          return;
        }
        this.armazemViatura = result["armazemViatura"];
      } else if (result["tecnico"]) {
        this.tecnico = result["tecnico"];
        this.refresh = true;
      }
    },

    async transferir() {
      if (this.armazemViatura.id == 0) {
        toast("Selecione o Armazem Viatura", {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 1000,
        });
        return;
      }
      if (this.armazemDestino.id == 0) {
        toast("Selecione o Armazem Destino", {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 1000,
        });
        return;
      }
      if (this.tecnico.id == 0) {
        toast("Selecione o Tecnico", {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 1000,
        });
        return;
      }

      const data = {
        tecnico_id: this.tecnico.id,
        armazem_origem_id: this.armazemViatura.id,
        armazem_destino_id: this.armazemDestino.id,
      };
      const res = await this.create(
        data,
        `${this.baseURl}/api/v1/stock/transferir/all/`,
      );
      console.log("tranfer response:", res);
      if (res) {
        toast("Artigos transferidos com sucesso", {
          theme: "auto",
          type: "success",
          position: "top-center",
          autoClose: 1000,
        });

        this.refresh = true;
      } else {
        toast("Erro ao transferir artigos", {
          theme: "auto",
          type: "error",
          position: "top-center",
          autoClose: 1000,
        });
      }
    },

    async getarmazemViatura() {
      if (this.tecnico.id == 0) {
        return;
      }
      const armazem = await this.select(
        `${this.baseURl}/api/v1/armazem/tecnico/${this.tecnico.id}/`,
      );
      if (armazem) {
        this.armazemViatura = armazem;
      }
    },

    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        console.log("Data successfully updated:", res.data);
        return true;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },
    async remove(url) {
      // console.log("Data:", data.id)
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },
  },
  async created() {
    // Se veio um ID via props, buscar esse técnico
  },

  // created() {
  //     this.tecnico = { id: 0, user: "" }

  // },

  watch: {
    // 'artigo.equipamento': {
    //     handler(newVal, oldVal) {
    //         console.log('artigo.equipamento changed:', newVal);
    //         if (newVal.id != 0) {
    //             this.getEquipamentoCount()
    //         }
    //     },
    //     deep: true
    // }

    tecnico: {
      handler(newVal, oldVal) {
        console.log("tecnico changed:", newVal);
        if (newVal.id != 0) {
          this.getarmazemViatura();
        }
      },
      deep: true,
    },
    parent_tecnico: {
      handler(newVal, oldVal) {
        console.log("parent_tecnico changed:", newVal);
        if (newVal.id != 0) {
          this.tecnico = newVal;
          this.getarmazemViatura();
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
@import "primevue/resources/themes/aura-light-green/theme.css";
@import "primevue/resources/themes/saga-blue/theme.css";
@import "primevue/resources/primevue.min.css";
@import "primeicons/primeicons.css";

.form_btn_container {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: rgba(93, 93, 152, 0.55);
  padding: 1rem;
}

.form_container {
  display: flex;
  gap: 2rem;
  padding: 1rem;
  border-radius: 10px;
}

.left_form {
  display: flex;
  flex-direction: column;
  /* gap: 0.2rem; */
  gap: 1rem;
}

h3 {
  display: flex;
  padding: 0.4rem;
  color: white;
}

label {
  display: block;
  color: white;
  /* font-weight: bold; */
  font-size: 14px;
  padding: 0.2rem;
  min-width: 1rem;
  text-wrap: nowrap;
}

input[type="text"],
input[type="password"],
select {
  /* width: 20px; */
  padding: 0.3rem;
  /* Reduce padding */
  font-size: 10px;
  /* Decrease font size */
  border-radius: 5px;
  border: 1px solid #cccccc;
}

.input_field.textarea {
  /* Define width and height as needed */
  width: 200px;
  height: 100px;
  /* Add other styles as needed */
}

.btn_div {
  color: white;
  display: flex;
  padding-left: 1rem;
  align-items: center;
  gap: 0.6rem;
}

.btn {
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background-color: rgb(0, 102, 152);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 0.5rem 0.8rem;
  cursor: pointer;
  gap: 0.5rem;
}

.data_set_class {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  border-radius: 10px;
  background-color: rgba(93, 93, 152, 0.55);
}

.data_set {
  font-size: 14px;
  color: white;
  display: flex;
  gap: 0.3rem;
}

.right_form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.5rem;
  align-items: center;
  /* display: none; */
}

.img_container {
  margin-top: -0.5rem;
  /* margin-left: 3rem; */
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.img_btn_container {
  display: flex;
  gap: 0.5rem;
}

.img_container {
  display: flex;
  width: 150px;
  aspect-ratio: 1/1;
  height: auto;
}

.img_container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.signature_container {
  display: flex;
  gap: 1rem;
}

.tpa_certificado_container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.signature_div {
  display: flex;
  gap: 1rem;
}

.signature_field_container {
  display: flex;
  width: 100px;
  height: auto;
  background-color: #626288;
  border-radius: 0.2rem;
}

.signature_field_container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.2rem;
}

.signature_icon_container {
  display: flex;
  justify-content: center;
  /* align-items: center; */
  padding-top: 1rem;
}

.right_input_container {
  /* padding: 0.8rem; */
  margin-top: 0.5rem;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  /* border:1px solid white; */
  border-radius: 0.5rem;
  /* background-color: rgba(93, 93, 152, 0.55); */
}

/* .signature_img_container i{
        margin-top:1rem
    } */

.input_container {
  display: flex;
  align-items: center;
  gap: 1rem;
  /* Adjust spacing between label and input field */
}

.input_label {
  width: 100px;
  /* Adjust label width as needed */
  color: white;
  font-size: 14px;
}

.input_field {
  flex: 1;
  /* Take remaining space */
  padding: 0.3rem;
  font-size: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.rae_container {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-radius: 10px;
  padding: 1rem;
  background-color: rgba(93, 93, 152, 0.55);
}

.red-border {
  /* border: 1px solid red; */
  background-color: rgba(176, 88, 88, 0.664);
}

.text-white {
  color: var(--label);
}
</style>
